import React, { useEffect, useRef, useState } from 'react';
import { Morevert } from '@dsny/dsny-component-library/icons';
import { useTranslation } from 'react-i18next';
import {
  ContextDropdownBox,
  ContextDropdownContainer,
  ContextDropdownList,
  DropdownItem,
  DropdownItemNoCSV,
  MoreButtondWrapper,
} from './ContextDropdown.styles';

interface ContextDropdownProps {
  songId: string;
  isExportAvailable: boolean;
  displayMenuOnTop: boolean;
  handleNavigate: (songId: string) => void;
  exportCSV: (songIds: string[]) => void;
}

const ContextDropdown: React.FC<ContextDropdownProps> = ({
  songId,
  isExportAvailable,
  displayMenuOnTop,
  handleNavigate,
  exportCSV,
}) => {
  const { t } = useTranslation();
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);

  // Handling toggle dropdown
  const toggleDropdown = () => {
    setIsDropdownOpen((prev) => !prev);
  };

  // Handling navigate to airplay report
  const handleNavigateToAirPlay = () => {
    setIsDropdownOpen(false);
    handleNavigate(songId);
  };

  // Handling download CSV
  const handleDownload = () => {
    setIsDropdownOpen(false);
    exportCSV([songId]);
  };

  // Closes dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target as Node)
      ) {
        setIsDropdownOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  return (
    <>
      {/*  Context dropdown menu */}
      <ContextDropdownContainer ref={dropdownRef}>
        {/* More button */}
        <MoreButtondWrapper onClick={toggleDropdown}>
          <Morevert />
        </MoreButtondWrapper>

        {isDropdownOpen && (
          <ContextDropdownBox displayTop={displayMenuOnTop}>
            <ContextDropdownList>
              {/* Airplay report */}
              <DropdownItem onClick={handleNavigateToAirPlay}>
                {t('LIBRARY_AIRPLAY_REPORT_MENU')}
              </DropdownItem>

              {/* Export CSV */}
              {isExportAvailable ? (
                <DropdownItem onClick={handleDownload}>
                  {t('LIBRARY_EXPORT_CSV_MENU')}
                </DropdownItem>
              ) : (
                /* CSV not available */
                <DropdownItemNoCSV>
                  {t('LIBRARY_EXPORT_CSV_NOT_AVAILABLE')}
                </DropdownItemNoCSV>
              )}
            </ContextDropdownList>
          </ContextDropdownBox>
        )}
      </ContextDropdownContainer>
    </>
  );
};

export default ContextDropdown;
